import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { damagesQueryKeys } from "./queryKeys"


export function useDamagesStats(parameters, config = {}) {
    const url = "damages/stats/"

    const queryParameters = useExtendWithSubnetworks(parameters, API_MODULE_ROADWAY)
    const queryKey = damagesQueryKeys["stats"](queryParameters)

    return useRoadQuery(
        url,
        queryKey,
        queryParameters,
        config,
    )
}
